<template>
    <div>
        <header>
            <h1>Akta kartīte</h1>
        </header>
        <hr>
        <div class="contentMenu">
            <div class="menuItem" @click="changeSection('main')" :class="{'active': section === 'main'}">Pamatinformācija</div>
            <div class="menuItem" @click="changeSection('agreement')" :class="{'active': section === 'agreement'}">Līguma informācija</div>
            <div class="menuItem" @click="changeSection('items')" :class="{'active': section === 'items'}">Priekšmeti</div>
            <div class="menuItem" @click="changeSection('documents')" :class="{'active': section === 'documents'}">Dokumenti</div>
            <div class="menuItem" @click="changeSection('other')" :class="{'active': section === 'other'}">Citi lauki</div>
        </div>
        <div class="content">
            <div class="loader" v-if="loading">
                <img src="/images/loading.svg" alt="Loading">
            </div>
            <div class="main">
                <div class="section" v-if="section == 'main'">
                    <div class="sectionTitle">Pamatinformācija</div>
                    <div class="sectionContent">
                        <div class="row">
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="act_number">Akta numurs</label>
                                    <input autocomplete="off" type="text" id="act_number" name="act_number" v-model="act_number" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label>Datums</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="receiver">Pieņēmējs</label>
                                    <input type="text" id="receiver" name="receiver" v-model="receiver" class="form-control">
                                    <small class="muted">Jaunajiem aktiem lauks tiks aizpildīts automātiski.</small>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="transfer_type_id">Ieguves veids</label>
                                    <select name="transfer_type_id" id="transfer_type_id" v-model="transfer_type_id" class="form-control">
                                        <option key="transfer_type_empty" :value="null">Nav norādīts</option>
                                        <option v-for="transfer_type in this.$props.transfer_types" :key="transfer_type.id" :value="transfer_type.id">{{transfer_type.collection_title}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="giver">Nodevējs</label>
                                    <input type="text" id="giver" name="giver" v-model="giver" class="form-control">
                                    <small class="muted">Jaunajiem aktiem lauks tiks aizpildīts automātiski.</small>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="keeper">Glabātājs</label>
                                    <input type="text" id="keeper" name="keeper" v-model="keeper" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="act_copies">Eksemplāri</label>
                                    <input type="number" id="act_copies" name="act_copies" v-model="act_copies" class="form-control">
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="annex_to_the_act">Pielikumā</label>
                                    <textarea name="annex_to_the_act" id="annex_to_the_act" rows="3" v-model="annex_to_the_act" class="form-control" disabled>{{annex_to_the_act}}</textarea>
                                    <small>Tiek aizpildīts automātiski no komijas lēmuma un līguma informācijas.</small>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div>
                            <div class="subsection">
                                <div class="title">
                                    Pieņēmēja informācija
                                </div>
                                <div class="actions">
                                    <button class="btn-sm btn-primary" @click="populateWithKeeperData()">Aizpildīt ar noklusējuma pieņēmēju</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="act_receiver_firstname">Pieņēmēja vārds</label>
                                        <input type="text" id="act_receiver_firstname" name="act_receiver_firstname" v-model="act_receiver_firstname" class="form-control">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="act_receiver_lastname">Pieņēmēja uzvārds</label>
                                        <input type="text" id="act_receiver_lastname" name="act_receiver_lastname" v-model="act_receiver_lastname" class="form-control">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="act_receiver_position">Pieņēmēja amats</label>
                                        <input type="text" id="act_receiver_position" name="act_receiver_position" v-model="act_receiver_position" class="form-control">
                                    </div>
                                </div>
                                <hr>
                            </div>
                        </div>
                        <div>

                            <div class="subsection">
                                <div class="title">
                                    Nodevēja informācija
                                </div>
                                <div class="actions">

                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="act_giver_type">Nodevēja veids</label>
                                        <select name="act_giver_type" id="act_giver_type"  v-model="act_giver_type" class="form-control">
                                            <option :value="null">Nav izvēlēts</option>
                                            <option value="individual">Fiziska persona</option>
                                            <option value="legal_person">Juridiska personas</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="act_giver_type != null">
                                <div class="col-4" v-if="act_giver_type=='legal_person'">
                                    <div class="form-group">
                                        <label for="act_giver_institution_name">Nodevēja institūcijas nosaukums</label>
                                        <input type="text" id="act_giver_institution_name" name="act_giver_institution_name" v-model="act_giver_institution_name" class="form-control">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="act_giver_reg_number">
                                            <span v-if="act_giver_type=='legal_person'">Reģistrācijas numurs</span>
                                            <span v-if="act_giver_type=='individual'">Personas kods</span>
                                        </label>
                                        <input type="text" id="act_giver_reg_number" name="act_giver_reg_number" v-model="act_giver_reg_number" class="form-control">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="act_giver_position">Amats</label>
                                        <input type="text" id="act_giver_position" name="act_giver_position" v-model="act_giver_position" class="form-control">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="act_giver_firstname">Vārds</label>
                                        <input type="text" id="act_giver_firstname" name="act_giver_firstname" v-model="act_giver_firstname" class="form-control">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="act_giver_lastname">Uzvārds</label>
                                        <input type="text" id="act_giver_lastname" name="act_giver_lastname" v-model="act_giver_lastname" class="form-control">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="act_giver_address">Adrese</label>
                                        <input type="text" id="act_giver_address" name="act_giver_address" v-model="act_giver_address" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="subsection">
                            <div class="title">
                                Akta sagatavotāja informācija
                            </div>
                            <div class="actions"><button class="btn btn-sm btn-primary" @click="populateActAuthorWithCurrentUser()">Aizpildīt ar saviem datiem</button></div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_author_firstname">Vārds</label>
                                    <input type="text" id="act_author_firstname" v-model="act_author_firstname" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_author_lastname">Uzvārds</label>
                                    <input type="text" id="act_author_lastname" v-model="act_author_lastname" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_author_position">Amats</label>
                                    <input type="text" id="act_author_position" v-model="act_author_position" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="subsection">
                          <div class="title">
                            Priekšmeta informācijas atjaunošana
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label>Vai atjaunot priekšmetu informāciju no akta laukiem - nodevējs, ieguves veids</label>
                            <div class="selectButtonsWrapper">
                              <div class="selectBtn" :class="{'active':populate_items_fields == true}"  @click="populate_items_fields = true">Jā</div>
                              <div class="selectBtn" :class="{'active':populate_items_fields == false}" @click="populate_items_fields = false">Nē</div>
                            </div>
                          </div>
                        </div>


                        <div class="row">
                            <div class="col-12 text-right">
                                <button class="btn btn-primary" @click="save()">Saglabāt</button>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="section" v-if="section == 'items'">
                    <div class="sectionTitle">Priekšmeti</div>
                    <div class="sectionContent">
                        <div class="subsection">
                            <div class="title">
                                Priekšmetu skaits
                            </div>
                            <div class="actions">
                                <button class="btn-sm btn-primary" @click="calculateItemsCount()">Automātiski saskaitīt</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="items_count" class="noTransform">KOPĀ</label>
                                    <input type="number" id="items_count" name="items_count" v-model="items_count" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="tmr_count" class="noTransform">TMR</label>
                                    <input type="number" id="tmr_count" name="tmr_count" v-model="tmr_count" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="tmrplg_count" class="noTransform">TMRplg</label>
                                    <input type="number" id="tmrplg_count" name="tmrplg_count" v-model="tmrplg_count" class="form-control">
                                </div>
                            </div>
                          <div class="col-3">
                            <div class="form-group">
                              <label for="tmrdg_count" class="noTransform">TMRdg</label>
                              <input type="number" id="tmrdg_count" name="tmrdg_count" v-model="tmrdg_count" class="form-control">
                            </div>
                          </div>
                          <div class="col-3">
                            <div class="form-group">
                              <label for="tmrdgplg_count" class="noTransform">TMRdg plg</label>
                              <input type="number" id="tmrdgplg_count" name="tmrdgplg_count" v-model="tmrdgplg_count" class="form-control">
                            </div>
                          </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="tmrfn_count" class="noTransform">TMRfn</label>
                                    <input type="number" id="tmrfn_count" name="tmrfn_count" v-model="tmrfn_count" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="tmrfnplg_count" class="noTransform">TMRfnplg</label>
                                    <input type="number" id="tmrfnplg_count" name="tmrfnplg_count" v-model="tmrfnplg_count" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="pk_count" class="noTransform">PK</label>
                                    <input type="number" id="pk_count" name="pk_count" v-model="pk_count" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="text-right mt-2 mb-2">
                                    <button data-toggle="modal" data-target="#newitemmodal" class="btn btn-primary">Pievienot jaunu</button>
                                </div>
                                <div class="modal" tabindex="-1"  id="newitemmodal" ref="vuemodal" key="newitemmodal">
                                    <div class="modal-dialog modal-lg  modal-dialog-centered" role="document">
                                        <div class="modal-content">
                                            <div class="loader" v-if="loading">
                                                <img src="/images/loading.svg" alt="Loading">
                                            </div>
                                            <div class="modal-header bg-primary text-white">
                                                <h5 class="modal-title">Priekšmeta pievienošana</h5>
                                                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div class="modal-body">
                                                <div class="row">
                                                    <div class="col-12 subsection">
                                                        <div class="title">
                                                            Jaunā priekšmeta dati
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="form-group">
                                                            <label for="new_item_cipher">Šifrs</label>
                                                            <select name="new_item_cipher" id="new_item_cipher" v-model="new_item_cipher" class="form-control form-control-sm" :class="{'is-invalid':errors && ( 'new_item_cipher' in errors)}" autocomplete="off">
                                                                <option v-for="cipher in ciphers" :value="cipher.title" :key="cipher.id">{{cipher.title}}</option>
                                                            </select>
                                                            <small class="text-danger" v-if="errors && errors.new_item_cipher">{{errors.new_item_cipher[0]}}</small>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="form-group">
                                                            <label for="new_item_number">Numurs</label>
                                                            <input type="text" v-model="new_item_number" class="form-control form-control-sm" :class="{'is-invalid':errors && ( 'new_item_number' in errors)}" autocomplete="off">
                                                            <small class="text-danger" v-if="errors && errors.new_item_number">{{errors.new_item_number[0]}}</small>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="form-group">
                                                            <label for="new_item_subnumber">Apakšnumurs</label>
                                                            <input type="text" v-model="new_item_subnumber" class="form-control form-control-sm" :class="{'is-invalid':errors && ( 'new_item_subnumber' in errors)}" autocomplete="off">
                                                            <small class="text-danger" v-if="errors && errors.new_item_subnumber">{{errors.new_item_subnumber[0]}}</small>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 subsection">
                                                        <div class="title">
                                                           Kopējamā priekšmeta dati
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <label for="copy_item_cipher">Šifrs</label>
                                                        <select name="copy_item_cipher" id="copy_item_cipher" v-model="copy_item_cipher" class="form-control form-control-sm">
                                                            <option v-for="cipher in ciphers" :value="cipher.title" :key="cipher.id">{{cipher.title}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="form-group">
                                                            <label for="copy_item_number">Numurs</label>
                                                            <input type="text" v-model="copy_item_number" class="form-control form-control-sm">
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="form-group">
                                                            <label for="copy_item_subnumber">Apakšnumurs</label>
                                                            <input type="text" v-model="copy_item_subnumber" class="form-control form-control-sm">
                                                        </div>
                                                    </div>
                                                    <div class="col-12 text-right">
                                                        <button class="btn btn-primary" v-if="new_loading == false" @click="create()" key="new_item_btn">Pievienot</button>
                                                        <button type="button" class="btn btn-primary"  v-if="new_loading == true" disabled key="new_item_loading"><i class="fas fa-spinner fa-spin"></i> Pievieno..</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <table class="table table-responsive-xl table-hover">
                            <thead class="bg-light">
                            <tr>
                                <th>Attēls</th>
                                <th>Numurs</th>
                                <th>Kolekcija</th>
                                <th>Nosaukums</th>
                                <th>Apraksts</th>
                                <th>Darbības</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr  v-for="item in items" :key="item.id">
                                <td><img v-if="item.images.length > 0" :src="'/image/thumb/'+item.images[0].file_name"></td>
                                <td>{{item.cipher}} {{item.item_number}}<span v-if="item.item_subnumber">-{{item.item_subnumber}}</span></td>
                                <td><span v-if="item.collection">{{item.collection.title}}</span></td>
                                <td><span v-if="item.title">{{item.title.title}}</span></td>
                                <td>{{item.description}}</td>
                                <td class="actions"><item-edit-component
                                    :key="'edit-component-'+item.id"
                                    :transfer_types="transfer_types"
                                    :item="item"
                                    :item_titles="item_titles"
                                    :item_collections ="item_collections "
                                    :scientific_themes="scientific_themes"
                                    :ciphers="ciphers"
                                    :copyrights="copyrights"
                                ></item-edit-component>
                                <div class="delete" @click="deleteItem(item.id)">
                                    <span class="material-icons">close</span>
                                </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="section" v-if="section == 'agreement'">
                    <div class="sectionTitle">Līguma informācija</div>

                   <div class="sectionContent">
                       <div class="row">
                           <div class="col-4">
                               <div class="form-group">
                                   <label for="purchase_commission_decision">Krājuma komisijas lēmuma Nr.</label>
                                   <input type="text" id="purchase_commission_decision" name="purchase_commission_decision" v-model="purchase_commission_decision" class="form-control">
                               </div>
                           </div>
                           <div class="col-4">
                               <div class="form-group">
                                   <label>Lēmuma datums</label>
                                   <v-date-picker
                                       :popover="{ visibility: 'click' }"
                                       @change="search()"
                                       mode="single"
                                       v-model="decision_date"
                                       :type="'date'"
                                       :locale="'LV'"
                                       color="teal"
                                       :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                   />
                               </div>
                           </div>
                           <div class="col-4">
                               <div class="form-group">
                                   <label for="decision_date_old">Lēmuma datums (vārdiski)</label>
                                   <input disabled type="text" id="decision_date_old" name="decision_date_old" v-model="decision_date_old" class="form-control">
                               </div>
                           </div>
                       </div>
                       <div class="row">
                           <div class="col-12">
                               <div class="form-group">
                                   <label for="agreement_type">Līguma veids</label>
                                   <select name="agreement_type" id="agreement_type" v-model="agreement_type" class="form-control">
                                       <option :value="null">Nav izvēlēts</option>
                                       <option value="purchase">Pirkuma līgums</option>
                                       <option value="gift">Dāvinājuma līgums</option>
                                   </select>
                               </div>
                           </div>
                       </div>

                        <div class="w-100" v-if="agreement_type != null">
                            <div class="row">
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="agreement_number">Līguma numurs</label>
                                        <input type="text" id="agreement_number" name="agreement_number" v-model="agreement_number" class="form-control">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label>Līguma datums</label>
                                        <v-date-picker
                                            :popover="{ visibility: 'click' }"
                                            mode="single"
                                            v-model="agreement_date"
                                            :type="'date'"
                                            :locale="'LV'"
                                            color="teal"
                                            :masks="{
                                    input: ['DD.MM.YYYY']
                                }"
                                        />
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="total_cost">Līguma summa (EUR)</label>
                                        <input type="text" id="total_cost" name="total_cost" v-model="total_cost" class="form-control">
                                        <small class="muted">Aizpilda tikai pirkuma līgumiem</small>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-12 subsection">
                                    <div class="title">
                                        Muzeja puses rekvizīti
                                    </div>
                                    <div class="actions">
                                        <button class="btn-sm btn-primary" @click="populateWithSignerData()">Aizpildīt ar noklusējuma parakstītāju</button>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="agreement_receiver_firstname">Vārds</label>
                                        <input type="text" id="agreement_receiver_firstname" name="agreement_receiver_firstname" v-model="agreement_receiver_firstname" class="form-control">
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="agreement_receiver_lastname">Uzvārds</label>
                                        <input type="text" id="agreement_receiver_lastname" name="agreement_receiver_lastname" v-model="agreement_receiver_lastname" class="form-control">
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="agreement_receiver_position">Amats</label>
                                        <input type="text" id="agreement_receiver_position" name="agreement_receiver_position" v-model="agreement_receiver_position" class="form-control">
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="agreement_receiver_legal_basis">Juridiskais pamats</label>
                                        <input type="text" id="agreement_receiver_legal_basis" name="agreement_receiver_legal_basis" v-model="agreement_receiver_legal_basis" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-12 subsection">
                                    <div class="title">
                                        Otras puses rekvizīti
                                    </div>
                                    <div class="actions">
                                        <button class="btn-sm btn-primary" @click="populateWithDataFromAct()">Aizpildīt ar informāciju no akta</button>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="giver_type">Personas veids</label>
                                        <select name="agreement_giver_type" id="agreement_giver_type" v-model="agreement_giver_type" class="form-control">
                                            <option :value="null">Nav izvēlēts</option>
                                            <option value="legal_person">Juridiska persona</option>
                                            <option value="individual">Fiziska persona</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="agreement_giver_type != null">
                               <div class="col-3" v-if="agreement_giver_type==='legal_person'">
                                   <div class="form-group">
                                       <label for="agreement_giver_institution_name">Institūcijas nosaukums</label>
                                       <input type="text" id="agreement_giver_institution_name" name="agreement_giver_institution_name" v-model="agreement_giver_institution_name" class="form-control">
                                   </div>
                               </div>
                               <div class="col-3">
                                   <div class="form-group">
                                       <label for="agreement_giver_reg_number">
                                           <span v-if="agreement_giver_type ==='legal_person'" key="legal_person">Reģistrācijas numurs</span>
                                           <span v-if="agreement_giver_type ==='individual'" key="individual">Personas kods</span>
                                       </label>
                                       <input type="text" id="agreement_giver_reg_number" name="agreement_giver_reg_number" v-model="agreement_giver_reg_number" class="form-control">
                                   </div>
                               </div>
                               <div class="col-3" v-if="agreement_giver_type==='legal_person'">
                                   <div class="form-group">
                                       <label for="agreement_giver_position">Amats</label>
                                       <input type="text" id="agreement_giver_position" name="agreement_giver_position" v-model="agreement_giver_position" class="form-control">
                                   </div>
                               </div>
                               <div class="col-3">
                                   <div class="form-group">
                                       <label for="agreement_giver_firstname">Vārds</label>
                                       <input type="text" id="agreement_giver_firstname" name="agreement_giver_firstname" v-model="agreement_giver_firstname" class="form-control">
                                   </div>
                               </div>
                               <div class="col-3">
                                   <div class="form-group">
                                       <label for="agreement_giver_lastname">Uzvārds</label>
                                       <input type="text" id="agreement_giver_lastname" name="agreement_giver_lastname" v-model="agreement_giver_lastname" class="form-control">
                                   </div>
                               </div>
                               <div class="col-3">
                                   <div class="form-group">
                                       <label for="agreement_giver_address">Adrese</label>
                                       <input type="text" id="agreement_giver_address" name="agreement_giver_address" v-model="agreement_giver_address" class="form-control">
                                   </div>
                               </div>
                           </div>
                            <hr>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="agreement_special_usage_rules">Speciālie lietošanas noteikumi priekšmetiem</label>
                                        <textarea
                                            id="agreement_special_usage_rules"
                                            name="agreement_special_usage_rules"
                                            v-model="agreement_special_usage_rules"
                                            class="form-control">{{agreement_special_usage_rules}}</textarea>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="agreement_giver_bank_title">Bankas nosaukums</label>
                                        <input type="text" id="agreement_giver_bank_title" name="agreement_giver_bank_title" v-model="agreement_giver_bank_title" class="form-control">
                                    </div>
                                    <div class="form-group">
                                        <label for="agreement_giver_bank_code">BIC / SWIFT</label>
                                        <input type="text" id="agreement_giver_bank_code" name="agreement_giver_bank_code" v-model="agreement_giver_bank_code" class="form-control">
                                    </div>
                                    <div class="form-group">
                                        <label for="agreement_giver_bank_account_number">Bankas konts</label>
                                        <input type="text" id="agreement_giver_bank_account_number" name="agreement_giver_bank_account_number" v-model="agreement_giver_bank_account_number" class="form-control">
                                    </div>
                                </div>
                            </div>
                    </div>
                   <div class="row">
                       <div class="col-12 text-right">
                           <button class="btn btn-primary" @click="save()">Saglabāt</button>
                       </div>
                   </div>
                </div>
                </div>
                <div class="section" v-if="section == 'documents'">
                    <div class="sectionTitle">Saistītie faili</div>
                    <div class="sectionContent">
                        <div class="row">
                            <div class="col-12">
                                <dropzone ref="files" @vdropzone-success="dropzoneFileSuccess" @vdropzone-error="dropzoneFileError" :useCustomSlot=true :options="{headers:headers, previewTemplate: template(),url: '/dashboard/api/acts/'+id+'/fileUpload',maxFilesize: 10,  thumbnailWidth: 20}" id="file">
                                    <div class="dropzone-custom-content">
                                        <h3 class="dropzone-custom-title">Pievienot saistīto dokumentu.</h3>
                                    </div>
                                </dropzone>
                                <div  class="filesList">
                                    <div class="file" v-for="file in files" :key="file.id">
                                        <div class="fileName">{{file.file_name}}</div>
                                        <div class="actions">
                                            <a :href="'/dashboard/api/acts/'+id+'/fileDownload/'+file.id" class="download"> <span class="material-icons">download</span></a>
                                            <div @click="deleteFile(id,file.id)" class="delete"> <span class="material-icons">close</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="section == 'other'">
                    <div class="section">
                        <div class="sectionTitle">Nelietotie lauki</div>
                        <div class="sectionContent">
                            <div class="row">
                                <div class="col-12">
                                    <div class="unusedField">
                                        <div class="fieldTitle">Eksemplāri (teksta formā)</div>
                                        <div class="fieldValue">{{act_copies_old}}</div>
                                    </div>
                                    <div class="unusedField">
                                        <div class="fieldTitle">Priekšmetu skaits (teksta formā)</div>
                                        <div class="fieldValue">{{items_count_old}}</div>
                                    </div>
                                    <div class="unusedField">
                                        <div class="fieldTitle">Nodošanas veids (vārdiski)</div>
                                        <div class="fieldValue">{{transfer_type}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="sidebar">
                <div class="section" v-if="section=='main'">
                    <div class="sectionTitle">Darbības</div>
                    <div class="sectionContent">
                        <div class="row">
                            <div class="col-12 text-center">
                                <a :href="'/acts/'+id+'/generateAct'" class="btn btn-primary" target="_blank">Ģenerēt aktu</a>
                            </div>
                          <br>
                          <br>
                          <div class="col-12 text-center">
                            <a :href="'/acts/'+id+'/generateAct?edoc=1'" class="btn btn-primary" target="_blank">Ģenerēt el. aktu</a>
                          </div>
                            <hr>
                            <div class="col-12 text-center">
                                <a :href="'/acts/'+id+'/generateAgreement'" class="btn btn-primary" target="_blank">Ģenerēt līgumu</a>
                            </div>
                          <br>
                          <br>
                          <div class="col-12 text-center">
                          <a :href="'/acts/'+id+'/generateAgreement?edoc=1'" class="btn btn-primary" target="_blank" >Ģenerēt el. līgumu</a>
                          </div>
                            <hr>
                            <div class="col-12 text-center">
                                <a :href="'/acts/'+id+'/generateItemsList'" class="btn btn-primary" target="_blank">Ģenerēt priekšmetu sarakstu</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section" v-if="section=='agreement'">
                    <div class="sectionTitle">Veco aktu lauki</div>
                    <div class="sectionContent">
                            <div class="alert alert-warning">Šos laukus aizpilda tikai vecajiem aktiem.</div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="purchase_agreement">Pirkuma līguma numurs</label>
                                    <input type="text" id="purchase_agreement" name="purchase_agreement" v-model="purchase_agreement" class="form-control">
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Pirkuma līguma datums</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        @change="search()"
                                        mode="single"
                                        v-model="purchase_agreement_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                    input: ['DD.MM.YYYY']
                                }"
                                    />
                                    <small class="muted">Labotais datums no vārdiskā PL datuma</small>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="purchase_agreement_date_old">PL datums (vārdiski)</label>
                                    <input disabled type="text" id="purchase_agreement_date_old" name="purchase_agreement_date_old" v-model="purchase_agreement_date_old" class="form-control">
                                </div>
                            </div>
                            <hr>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="gift_agreement">Dāvinājuma līguma numurs</label>
                                    <input type="text" id="gift_agreement" name="gift_agreement" v-model="gift_agreement" class="form-control">
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Dāvinājuma līguma datums</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="gift_agreement_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                    input: ['DD.MM.YYYY']
                                }"
                                    />
                                    <small class="muted">Labotais datums no vārdiskā DL datuma</small>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="gift_agreement_date_old">DL datums (vārdiski)</label>
                                    <input disabled type="text" id="gift_agreement_date_old" name="gift_agreement_date_old" v-model="gift_agreement_date_old" class="form-control">
                                </div>
                            </div>
                    </div>
                </div>
                <div class="section">
                  <div class="sectionTitle">
                    Informācija
                  </div>
                  <div class="sectionContent" v-if="created_by">
                    <p class="small muted">Aktu sistēmā {{normalDateTime(created_at)}} pievienoja {{created_by.firstname}} {{created_by.lastname}}.</p>
                    <p class="small muted">Informācija pēdējo reizi atjaunota {{normalDateTime(updated_at)}}</p>
                  </div>
                  <div class="sectionContent" v-else>
                    <p class="small muted">Informācija par akta izveidotāju sistēmā nav pieejama.</p>
                  </div>
                </div>
                <div class="section" v-if="hasPermission(current_user,'can_access_all_acts')">

                <div class="sectionTitle">Lietotāju piekļuves</div>
                <div class="sectionContent">
                  <div v-if="true" class="form-group text-center">
                    <button class="btn btn-primary" data-toggle="modal" :data-target="'#modal-permissions'">Piekļuves pārvaldība</button>
                  </div>
                  <div v-if="true" class="modal fade" tabindex="-1"  :id="'modal-permissions'" ref="vuemodal">
                    <div class="modal-dialog modal-lg" role="document">
                      <div class="modal-content">
                        <div class="modal-header bg-primary text-white">
                          <h5 class="modal-title">Piekļuves pārvaldība</h5>
                          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <div class="row">
                            <div class="col-12">
                              <div class="form-group">
                                <label for="filter">Filtrs</label>
                                <input type="text" class="form-control" v-model="userFilter">
                              </div>
                            </div>
                            <div class="col-12 usersTable">
                              <table class="table">
                                <thead class="bg-primary text-white sticky-top">
                                <tr>
                                  <th>Lietotājs</th>
                                  <th>Var piekļūt un labot aktu</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="person" v-for="user in filteredUsers" :key="user.id">
                                  <td><strong>{{user.firstname}} {{user.lastname}}</strong></td>
                                  <td>
                                    <div v-if="users_can_edit.includes(user.id)" class="switch" :class="{'active': (users_can_edit.includes(user.id))}" @click="changePermission('remove','can_edit', user.id, id)"><span class="circle"></span></div>
                                    <div v-else class="switch" @click="changePermission('add','can_edit', user.id, id)"><span class="circle"></span></div>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
import Dropzone from 'vue2-dropzone';
import ItemEditComponent from "../items/ItemEditComponent";
export default {
    props:['id','transfer_types','settings','item_titles','item_collections','scientific_themes','ciphers','current_user','copyrights','all_users_list'],
    components: {
        ItemEditComponent,
        Dropzone
    },
    mounted()
    {
        this.loading = true;
        var that = this;
        EventBus.$on('open_next_item_edit_modal', (current_item_id) =>{
            that.openNextItemModal(current_item_id);
        });
        EventBus.$on('open_prev_item_edit_modal', (current_item_id) =>{
            that.openPrevItemModal(current_item_id);
        });
        EventBus.$on('files_list_updated', (files) =>{
            that.files = files;
        });
        EventBus.$on('items_updated', (items) =>{
            that.items = items;
            console.log("items_updated");
        });
        EventBus.$on('new_item_added', (data) =>{
            that.items = data.act.items;
            setTimeout(function(){
                $('#edit-'+data.item.id).modal('show');
            },500);

        });
      this.getAct(this.$props.id);
      EventBus.$on('act_loaded', (act) =>{
          //Akta tabulas lauki
          that.old_act = act.old_act;
          that.act_number = act.act_number;
          that.date = moment(act.date, moment.ISO_8601)._d;
          that.receiver = act.receiver;
          that.transfer_type_id = act.transfer_type_id;
          that.transfer_type = act.transfer_type;
          that.giver = act.giver;
          that.act_copies_old = act.act_copies_old;
          that.items_count_old = act.items_count_old;
          that.purchase_commission_decision = act.purchase_commission_decision;
          that.keeper = act.keeper;
          that.decision_date_old = act.decision_date_old;
          that.purchase_agreement = act.purchase_agreement;
          that.purchase_agreement_date_old = act.purchase_agreement_date_old;
          that.gift_agreement = act.gift_agreement;
          that.gift_agreement_date_old = act.gift_agreement_date_old;
          that.act_copies = act.act_copies;
          that.items_count_old_from_text = act.items_count_old_from_text;
          that.items_count = act.items_count;
          that.tmr_count = act.tmr_count;
          that.tmrplg_count = act.tmrplg_count;
          that.tmrdg_count = act.tmrdg_count;
          that.tmrdgplg_count = act.tmrdgplg_count;
          that.tmrfn_count = act.tmrfn_count;
          that.tmrfnplg_count = act.tmrfnplg_count;
          that.pk_count = act.pk_count;
          that.transfer_type_id = act.transfer_type_id;
          that.decision_date = moment(act.decision_date, moment.ISO_8601)._d;
          that.purchase_agreement_date = moment(act.purchase_agreement_date, moment.ISO_8601)._d;
          that.gift_agreement_date = moment(act.gift_agreement_date, moment.ISO_8601)._d;


          that.files = act.files;
          that.items = act.items;
          that.details = act.details;

          that.created_by = act.created_by;
          that.created_at = moment(act.created_at, moment.ISO_8601)._d;
          that.updated_at = moment(act.updated_at, moment.ISO_8601)._d;

          //For act permissions
          that.users = act.users;

          //Akta lauki
          if(act.details)
          {

              that.act_receiver_firstname=act.details.act_receiver_firstname;
              that.act_receiver_lastname=act.details.act_receiver_lastname;
              that.act_receiver_position=act.details.act_receiver_position;
              that.act_giver_type=act.details.act_giver_type;
              that.act_giver_institution_name=act.details.act_giver_institution_name;
              that.act_giver_reg_number=act.details.act_giver_reg_number;
              that.act_giver_position=act.details.act_giver_position;
              that.act_giver_firstname=act.details.act_giver_firstname;
              that.act_giver_lastname=act.details.act_giver_lastname;
              that.act_giver_address=act.details.act_giver_address;
              that.annex_to_the_act=act.details.annex_to_the_act;
              that.act_author_firstname = act.details.act_author_firstname;
              that.act_author_lastname = act.details.act_author_lastname;
              that.act_author_position = act.details.act_author_position;


              that.agreement_type=act.details.agreement_type;
              that.agreement_number=act.details.agreement_number;
              that.agreement_date=moment(act.details.agreement_date, moment.ISO_8601)._d;
              that.agreement_receiver_firstname=act.details.agreement_receiver_firstname;
              that.agreement_receiver_lastname=act.details.agreement_receiver_lastname;
              that.agreement_receiver_position=act.details.agreement_receiver_position;
              that.agreement_receiver_legal_basis=act.details.agreement_receiver_legal_basis;
              that.agreement_giver_type=act.details.agreement_giver_type;
              that.agreement_giver_institution_name=act.details.agreement_giver_institution_name;
              that.agreement_giver_reg_number=act.details.agreement_giver_reg_number;
              that.agreement_giver_position=act.details.agreement_giver_position;
              that.agreement_giver_firstname=act.details.agreement_giver_firstname;
              that.agreement_giver_lastname=act.details.agreement_giver_lastname;
              that.agreement_giver_address=act.details.agreement_giver_address;
              that.agreement_special_usage_rules=act.details.agreement_special_usage_rules;
              that.agreement_giver_bank_title=act.details.agreement_giver_bank_title;
              that.agreement_giver_bank_code=act.details.agreement_giver_bank_code;
              that.agreement_giver_bank_account_number=act.details.agreement_giver_bank_account_number;
              that.total_cost=act.details.total_cost;

          }

          that.loading = false;


      })
    },
    data()
    {
      return {
          errors:[],
          section:"main",
          show_agreement_details:false,
          headers: {
              "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
          },
          template: function () {
              return `<div class="dz-preview dz-file-preview">
                    <div class="dz-details">
                        <div class="dz-filename"><span data-dz-name></span></div>
                        <div class="dz-size"><span data-dz-size></span></div>

                    </div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>

                </div>
            `;
          },
          loading:false,
          old_act:true,
          act_number:"",
          date:"",
          receiver:"",
          transfer_type:"",
          giver:"",
          act_copies_old:"",
          items_count_old:"",
          purchase_commission_decision:"",
          keeper:"",
          decision_date_old:"",
          purchase_agreement:"",
          purchase_agreement_date_old:"",
          gift_agreement:"",
          gift_agreement_date_old:"",
          act_copies:"",
          items_count_old_from_text:"",
          items_count:"",
          tmr_count:"",
          tmrplg_count:"",
          tmrdg_count:"",
          tmrdgplg_count:"",
          tmrfn_count:"",
          tmrfnplg_count:"",
          pk_count:"",
          transfer_type_id:"",
          decision_date:"",
          purchase_agreement_date:"",
          gift_agreement_date:"",


          //Akta lauki
          act_receiver_firstname:"",
          act_receiver_lastname:"",
          act_receiver_position:"",
          act_giver_type:null,
          act_giver_institution_name:"",
          act_giver_reg_number:"",
          act_giver_position:"",
          act_giver_firstname:"",
          act_giver_lastname:"",
          act_giver_address:"",
          annex_to_the_act:"",


          act_author_firstname:"",
          act_author_lastname:"",
          act_author_position:"",

          agreement_type:null,
          agreement_number:"",
          agreement_date:"",
          agreement_receiver_firstname:"",
          agreement_receiver_lastname:"",
          agreement_receiver_position:"",
          agreement_receiver_legal_basis:"",
          agreement_giver_type:"",
          agreement_giver_institution_name:"",
          agreement_giver_reg_number:"",
          agreement_giver_position:"",
          agreement_giver_firstname:"",
          agreement_giver_lastname:"",
          agreement_giver_address:"",
          agreement_special_usage_rules:"",
          agreement_giver_bank_title:"",
          agreement_giver_bank_code:"",
          agreement_giver_bank_account_number:"",
          total_cost:"",

          files:[],
          items:[],
          details:[],

          new_item_cipher:null,
          new_item_number:"",
          new_item_subnumber:"",
          new_loading: false,

          copy_item_cipher:null,
          copy_item_number:"",
          copy_item_subnumber:"",

          created_by:[],
          created_at:"",
          updated_at:"",

          populate_items_fields: false,
          users:[],
          userFilter:"",
      }
    },
    methods:{
        hasPermission(user,permission)
        {

          return user.allpermissions.some(function(p) {
            return p.name == permission;
          });
        },
        calculateItemsCount()
        {
            this.items_count = 0;
            this.tmr_count = 0;
            this.tmrdg_count = 0;
            this.tmrdgplg_count = 0;
            this.tmrplg_count = 0;
            this.tmrfn_count = 0;
            this.tmrfnplg_count = 0;
            this.pk_count = 0;
            this.items.forEach(item =>{
              if(item.cipher === 'TMR' || item.cipher === 'SM')
              {
                  this.tmr_count++;
              }
              if(item.cipher === 'TMRdg')
              {
                this.tmrdg_count++;
              }
              if(item.cipher === 'TMRdg plg')
              {
                this.tmrdgplg_count++;
              }
              if(item.cipher === 'TMRplg' || item.cipher === 'SMplg')
              {
                  this.tmrplg_count++;
              }
              if(item.cipher === 'TMRfn' || item.cipher === 'SMfn')
              {
                  this.tmrfn_count++;
              }
              if(item.cipher === 'TMRfnplg' || item.cipher === 'SMfnplg')
              {
                  this.tmrfnplg_count++;
              }
              if(item.cipher === 'PK')
              {
                  this.pk_count++;
              }
              this.items_count++;
          });

            this.save();
        },
        save()
        {
            var that = this;
            this.loading = true;
            var data = {
                act_number: this.act_number,
                date: this.date,
                receiver: this.receiver,
                transfer_type_id: this.transfer_type_id,
                giver: this.giver,
                keeper: this.keeper,
                act_copies: this.act_copies,

                act_receiver_firstname: this.act_receiver_firstname,
                act_receiver_lastname: this.act_receiver_lastname,
                act_receiver_position: this.act_receiver_position,

                act_giver_type: this.act_giver_type,
                act_giver_institution_name: this.act_giver_institution_name,
                act_giver_reg_number:this.act_giver_reg_number,
                act_giver_position: this.act_giver_position,
                act_giver_firstname: this.act_giver_firstname,
                act_giver_lastname: this.act_giver_lastname,
                act_giver_address: this.act_giver_address,
                annex_to_the_act: this.annex_to_the_act,

                act_author_firstname: this.act_author_firstname,
                act_author_lastname: this.act_author_lastname,
                act_author_position: this.act_author_position,

                //Pirkuma komisijas jaunie lauki
                purchase_commission_decision: this.purchase_commission_decision,
                decision_date: this.decision_date,
                //Visi līguma lauki

                agreement_type: this.agreement_type,
                agreement_number: this.agreement_number,
                agreement_date: this.agreement_date,
                agreement_receiver_firstname: this.agreement_receiver_firstname,
                agreement_receiver_lastname: this.agreement_receiver_lastname,
                agreement_receiver_position: this.agreement_receiver_position,
                agreement_receiver_legal_basis: this.agreement_receiver_legal_basis,
                agreement_giver_type: this.agreement_giver_type,
                agreement_giver_institution_name: this.agreement_giver_institution_name,
                agreement_giver_reg_number: this.agreement_giver_reg_number,
                agreement_giver_position: this.agreement_giver_position,
                agreement_giver_firstname: this.agreement_giver_firstname,
                agreement_giver_lastname: this.agreement_giver_lastname,
                agreement_giver_address: this.agreement_giver_address,
                agreement_special_usage_rules: this.agreement_special_usage_rules,

                agreement_giver_bank_title: this.agreement_giver_bank_title,
                agreement_giver_bank_code: this.agreement_giver_bank_code,
                agreement_giver_bank_account_number: this.agreement_giver_bank_account_number,

                total_cost: this.total_cost,

                //Priekšmetu skaits
                items_count: this.items_count,
                tmr_count: this.tmr_count,
                tmrplg_count: this.tmrplg_count,
                tmrdg_count: this.tmrdg_count,
                tmrdgplg_count: this.tmrdgplg_count,
                tmrfn_count: this.tmrfn_count,
                tmrfnplg_count: this.tmrfnplg_count,
                pk_count: this.pk_count,

                //Citi lauki
                // old_date:"",
                // transfer_type:"",
                // act_copies_old:"",
                // items_count_old:"",
                //decision_date_old: this.decision_date_old,
                //purchase_commission_date_old: this.purchase_commission_date_old,

                //Jaunajiem netiek lietoti, bet aizpildīti no līguma
                purchase_agreement: this.purchase_agreement,
                purchase_agreement_date: this.purchase_agreement_date,
                //purchase_agreement_date_old: this.purchase_agreement_date_old,

                //Jaunajiem netiek lietoti, bet aizpildīti no līguma
                gift_agreement: this.gift_agreement,
                gift_agreement_date: this.gift_agreement_date,
                //gift_agreement_date_old: this.gift_agreement_date_old,

                populate_items_fields: this.populate_items_fields,


            }
            axios.post('/dashboard/api/acts/'+this.$props.id+'/update',data)
                .then(response =>{
                    that.loading = false;
                    that.$toast.open(response.data.message);
                    EventBus.$emit('act_loaded',response.data.act);
                })
        },
        populateWithDataFromAct()
        {
            this.agreement_giver_type = this.act_giver_type;
            this.agreement_giver_institution_name =  this.act_giver_institution_name;
            this.agreement_giver_reg_number = this.act_giver_reg_number;
            this.agreement_giver_position = this.act_giver_position
            this.agreement_giver_firstname = this.act_giver_firstname;
            this.agreement_giver_lastname = this.act_giver_lastname;
            this.agreement_giver_address = this.act_giver_address;
        },
        populateWithKeeperData()
        {
          this.act_receiver_firstname = this.getSetting('keeper_firstname');
          this.act_receiver_lastname = this.getSetting('keeper_lastname');
          this.act_receiver_position = this.getSetting('keeper_position');
        },
        populateWithSignerData()
        {
            this.agreement_receiver_firstname = this.getSetting('agreement_receiver_firstname');
            this.agreement_receiver_lastname = this.getSetting('agreement_receiver_lastname');
            this.agreement_receiver_position = this.getSetting('agreement_receiver_position');
            this.agreement_receiver_legal_basis = this.getSetting('agreement_receiver_legal_basis');

        },
        populateActAuthorWithCurrentUser(){
            this.act_author_firstname = this.$props.current_user.firstname;
            this.act_author_lastname = this.$props.current_user.lastname;
            this.act_author_position = this.$props.current_user.position;
        },
        getSetting(key)
        {
            var found = false;
            for(var i = 0; i < this.settings.length; i++) {
                if (this.settings[i].setting_name == key) {
                    found = true;
                    return this.settings[i].setting_value;
                }
            }
            return "";
        },
        create()
        {
            var that = this;
            this.new_loading = true;
            axios.post('/dashboard/items/create',{
                id:that.id,
                new_item_cipher: that.new_item_cipher,
                new_item_number: that.new_item_number,
                new_item_subnumber: that.new_item_subnumber,
                copy_item_cipher: that.copy_item_cipher,
                copy_item_number: that.copy_item_number,
                copy_item_subnumber: that.copy_item_subnumber,
            }).then(response =>{
                if(response.data.status == 'ok')
                {
                    $(that.$refs.vuemodal).modal('hide');
                    that.$toast.open(response.data.message);
                    that.new_item_cipher="";
                    that.new_item_number="";
                    that.new_item_subnumber="";
                    that.copy_item_cipher="";
                    that.copy_item_number="";
                    that.copy_item_subnumber="";
                    EventBus.$emit('new_item_added', response.data);
                }
                if(response.data.status == 'error')
                {
                    that.$toast.error(response.data.message);
                    that.errors = response.data.errors;
                }
                that.new_loading = false;
            })
        },
        changeSection(section)
        {
          this.section = section;
        },
        changePermission(action,permission_type, user_id, act_id)
        {
          var that = this;
          axios.post('/dashboard/api/acts/'+act_id+'/changePermission',{
            'user_id': user_id,
            'action': action,
            'permission_type': permission_type
          })
              .then(response => {
                if(response.data.status == 'ok')
                {
                  that.users = response.data.users;
                  that.$toast.open(response.data.message);
                }
              })
        },

        dropzoneFileSuccess(file, response)
        {
            EventBus.$emit('files_list_updated', response.act.files);
            this.$toast.open({
                message:"Fails - "+response.file.file_name+" - veiksmīgi augšupielādēts.",
                type:"success"
            });
            this.$refs.files.removeFile(file);
        },
        dropzoneFileError(file, message, xhr)
        {
            this.$toast.open({
                message:"Faila augšupielāde neizdevās."+message,
                type:"error"
            });
            this.$refs.files.removeFile(file);
        },
        deleteItem(item_id)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst priekšmetu?',
                text: "Priekšmets tiks dzēsts.",
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                    if (result.value) {
                        axios.post('/dashboard/api/acts/' + that.$props.id + '/delete-item/' + item_id)
                            .then(response => {
                                if(response.data.status == 'ok')
                                {
                                    that.items = response.data.act.items;
                                    that.$toast.open(response.data.message);
                                }
                                if(response.data.status == 'error')
                                {
                                    that.$toast.error(response.data.message);
                                }
                            });
                    }
            });
        },
        deleteFile(actID,fileID)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst failu?',
                text: "Fails tiks neatgriezeniski dzēsts.",
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                if (result.value) {
                    axios.post('/dashboard/api/acts/' + actID + '/fileDelete/' + fileID)
                        .then(response => {
                            that.$toast.open("Fails dzēsts.");
                            EventBus.$emit('files_list_updated', response.data.act.files);
                        });
                }
            });
        },
        getAct(id)
        {
            this.loading=true;
            var that = this;
            axios.post('/dashboard/api/acts/'+id).then(response =>{
                if (response.data.status == 'ok')
                {
                    EventBus.$emit('act_loaded',response.data.act);
                }
            })
        },
        normalDate(date)
        {
            var d = moment(date).format('DD.MM.YYYY.');
            if(moment(d, 'DD.MM.YYYY.').isValid())
            {
                return d;
            }
            else
            {
                return null;
            }
        },
        normalDateTime(date)
        {
          var d = moment(date).format('DD.MM.YYYY. HH:mm');
          if(moment(d, 'DD.MM.YYYY.').isValid())
          {
            return d;
          }
          else
          {
            return null;
          }
        },
        openPrevItemModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)-1;
            if(index >= 0)
            {
                $('#edit-'+this.items_list[index+1]).modal('hide');
                $('#edit-'+this.items_list[index]).modal('show');
            }
            else {
                $('#edit-'+this.items_list[index+1]).modal('hide');
            }
        },
        openNextItemModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)+1;
            if(index <= this.items_list.length)
            {
                $('#edit-'+this.items_list[index-1]).modal('hide');
                $('#edit-'+this.items_list[index]).modal('show');
            }
            else{
                $('#edit-'+this.items_list[index-1]).modal('hide');
            }
        }
    },
    computed:{
        users_can_view: function(user)
        {
          var users = [];
          if(this.users)
          {
            this.users.forEach(user =>
            {
              if(user.permission_type == 'can_view')
              {
                users.push(user.user_id);
              }
            });
          }
          return users;
        },
        users_can_edit: function(user)
        {
          var users = [];
          if(this.users) {
            this.users.forEach(user => {
              if (user.permission_type == 'can_edit') {
                users.push(user.user_id);
              }
            });
          }
          return users;
        },
        filteredUsers:function()
        {
          var filterString = this.userFilter.toLowerCase();
          return this.all_users_list.filter(function(s) {
            if (s.firstname.toLowerCase().includes(filterString) ||
                s.lastname.toLowerCase().includes(filterString) ||
                filterString == ""
            )
            {
              return true;
            }
          });


        },
        items_list()
        {
            var that = this;
            if(that.items)
            {
                return that.items.map(item =>{
                    return item.id;
                });

            }
        }

    }
}
</script>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';

.usersTable
{
  max-height:80vh;
  overflow: auto;
  .switch{
    width:45px;
    height:25px;
    background:#eee;
    border-radius:15px;
    position:relative;
    display:block;
    cursor:pointer;
    .circle{
      position:absolute;
      top:2.5px;
      left:2.5px;
      height:20px;
      width:20px;
      background:#fff;
      border-radius:100%;
      transition:all .2s ease-in-out;
    }
    &.active{
      .circle{
        transform:translateX(17.5px);
        background:$blue;
      }
    }
  }
}

.selectButtonsWrapper{
  display:flex;
  gap:10px;
  .selectBtn{
    padding:10px 15px;
    border-radius:5px;
    border:2px solid #eee;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: bold;
    color:#777;
    line-height:1;
    transition: .2s all;
    &.active{
      border-color:$blue;
      color:#333;
    }
  }
}
.actions{
    display:flex;
    align-items: center;
    .delete{
        display:flex;
        align-items: center;
        justify-content: center;
        cursor:pointer;
        margin-left:auto;
        width:24px;
        height:24px;
        background-color:#ddd;
        color:#fff;
        transition:all .2s ease-in-out;
        border-radius:100%;
        &:hover{
            background-color:$red;
        }
    }
}
.loader{
    cursor: progress;
    position:absolute;

    width:100%;
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
    background:rgba(255,255,255,0.7);
    z-index:10;
    img{
        width:100px;
        height:100px;
    }

}

.images-wrapper{
    display: flex;
    .image{
        width:300px;
        height:150px;
    }
}
.content{
    position:relative;
    display:flex;
    .main{
        flex-basis:800px;
        flex-grow:1;
    }
    .sidebar{
        flex-basis:400px;
        flex-grow:0;
        flex-shrink:0;
    }
}
.section{
    box-shadow: 0 1px 10px rgba(0,0,0,.1);
    margin:15px;
    .subsection
    {
        width:100%;
        display:flex;
        align-items: center;
        padding-bottom:5px;
        padding-top:10px;
        border-bottom:solid 5px #eee;
        margin-bottom:15px;
        .title{
            font-size:18px;
            font-weight:bold;
        }
        .actions{
            margin-left:auto;
        }
    }
    hr{
        width:100%;
        display:block;
    }
    .sectionTitle{
        cursor:pointer;
        font-size:16px;
        font-weight: 700;
        text-transform: uppercase;
        padding:15px 20px;
        background-color:$blue;
        color:#fff;
    }
    .sectionContent{
        width:100%;
        padding:10px 20px 20px 20px;
        img{
            width:100px;
            height:auto;
        }
    }
}
.unusedField
{
    display:flex;
    margin-bottom:5px;
    .fieldTitle{
        color:#777;
        width:150px;
        font-weight:700;
    }
    .fieldValue{
        color:#777;
    }
}
</style>
